import { z } from "zod";
// Where a fact came from (Phase 4 design 6.2). The vocabulary lives here, in the vendor-free `schemas` package,
// because the tools (`@lafayette/agent-contract`) and the UI parts (`agent-ui-parts.ts`, shared with the mobile client)
// both carry it. `@lafayette/agent-contract` re-exports every name below, so existing imports keep working.
export const evidenceSources = Object.freeze([
    "CATALOG_FACT",
    "CUSTOMER_STATED_MEMORY",
    "BUSINESS_STATE",
    "EXTERNAL_OBSERVATION",
]);
export const evidenceEntityTypes = Object.freeze([
    "CATALOG_ITEM",
    "MEMORY_FACT",
    "CONCIERGE_REQUEST",
    "HANDOFF",
    "TRIP",
    "ITINERARY",
    "SAVED_ITEM",
    "PAYMENT_REQUEST",
    "PLACE",
]);
/** A closed code such as `PUBLISHED_CATALOG`, `CUSTOMER_APP`, `STAFF_RECORDED` or `GOOGLE_PLACES`. */
export const EVIDENCE_PROVENANCE_PATTERN = /^[A-Z][A-Z0-9_]{1,39}$/;
export const evidenceMetaSchema = z
    .strictObject({
    source: z.enum(evidenceSources),
    entity: z
        .strictObject({ type: z.enum(evidenceEntityTypes), id: z.string().min(1).max(64) })
        .nullable(),
    /** ISO 8601: when Lafayette read or last confirmed it. */
    observedAt: z.iso.datetime().nullable(),
    provenance: z.string().regex(EVIDENCE_PROVENANCE_PATTERN).nullable(),
})
    .refine((meta) => meta.source !== "EXTERNAL_OBSERVATION" || meta.observedAt !== null, {
    path: ["observedAt"],
    message: "an external observation always has observedAt",
});
